import { render, staticRenderFns } from "./VpnSupportBody.vue?vue&type=template&id=2097c0d5&scoped=true"
import script from "./VpnSupportBody.vue?vue&type=script&lang=js"
export * from "./VpnSupportBody.vue?vue&type=script&lang=js"
import style0 from "./VpnSupportBody.vue?vue&type=style&index=0&id=2097c0d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2097c0d5",
  null
  
)

export default component.exports